// @flow
import { Icon } from 'semantic-ui-react';
import React from 'react';

export const WarningIcon = () => <Icon color="red" name="warning" />;
